import * as React from "react";
import gql from "graphql-tag";
import { graphql, compose } from "react-apollo";

import BOText from "app/components/BOComponents/BOText/BOText";
import RefundRequestsSummary from "./Ops.RefundRequests.Summary";

type Props = {
  match: { params: { id: string } };
  refund_request: { fetchMore: Function };
};

type State = {
  data: any;
  view: string;
};

class Detail extends React.Component<Props, State> {
  constructor(props: Props) {
    super(props);

    this.state = {
      data: null,
      view: "Summary", // default to summary view
    };

    this.loadData = this.loadData.bind(this);
  }

  componentDidMount() {
    this.loadData();
  }

  loadData() {
    this.props.refund_request.fetchMore({
      updateQuery: (previousResult, { fetchMoreResult }) => {
        this.setState({ data: fetchMoreResult.refund_request[0] });
      },
    });
  }

  render() {
    return (
      <section>
        <div className="DetailTopBar">
          <BOText
            text="Summary"
            tag="span"
            class="BODetailItem"
            link={`/snapscan/ops/refund_requests/${this.props.match.params.id}/summary`}
            active="selected"
            onClick={() => this.setState({ view: "Summary" })}
          />
        </div>

        <section className="padded">
          <div
            style={{
              height: "calc(100vh - 120px)",
              overflowY: "auto",
              overflowX: "hidden",
            }}
          >
            {this.state.view === "Summary" && (
              <RefundRequestsSummary
                data={this.state.data}
                loadData={this.loadData}
              />
            )}
          </div>
        </section>
      </section>
    );
  }
}

const refundRequestsSummary = graphql(
  gql`
    query refund_request($id: String) {
      refund_request(id: $id) {
        id
        amount
        comments
        created_at
        original_payment_id
        status
        updated_at
        original_payment {
          reference
        }
        refund_payment {
          reference
        }
      }
    }
  `,
  {
    name: "refund_request",
    options({
      match: {
        params: { id },
      },
    }: any) {
      return {
        variables: {
          id: id,
        },
      };
    },
  }
);

export default compose<any>(refundRequestsSummary)(Detail);
